exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://use.typekit.net/srv0wme.css);", ""]);

// module
exports.push([module.id, "/*\r\n$breakpoint argument choices:\r\n- xs\r\n- sm\r\n- md\r\n- lg\r\n- xl\r\n*/\n.attachment-item a[data-v-4623d004] {\n  color: #3e3e3e;\n}\n.attachment-item a[data-v-4623d004]:hover {\n    color: #f55f40;\n}\n", ""]);

// exports
